import styled from 'styled-components';
import { Flag, useFeatureFlag } from '@algoan/dashboard/utils';

export const Indicator: React.FC<{
  title?: React.ReactNode;
  value: React.ReactNode;
  showIndicator?: boolean;
  onClick?: () => void;
  testId?: string;
  className?: string;
  fullWidth?: boolean;
}> = ({ title, value, showIndicator, onClick, testId, className, fullWidth = false }) => {
  const { active: areTransactionHidden } = useFeatureFlag(Flag.HIDE_THE_TRANSACTIONS);

  if (!showIndicator) return <></>;

  return (
    <IndicatorStyles.IndicatorContainer
      className={className}
      onClick={() => (!areTransactionHidden && !!onClick ? onClick() : null)}
      data-testid={testId}
      fullWidth={fullWidth}
    >
      <IndicatorStyles.IndicatorTitle underlineOnHover={!areTransactionHidden && !!onClick} fullWidth={fullWidth}>
        {title} {title && !fullWidth ? ':' : ''}
      </IndicatorStyles.IndicatorTitle>
      <IndicatorStyles.IndicatorValue paddingOnLeft={!!title}>{value}</IndicatorStyles.IndicatorValue>
    </IndicatorStyles.IndicatorContainer>
  );
};

export const IndicatorStyles = {
  IndicatorContainer: styled.div<{ fullWidth: boolean }>`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-basis: calc(50% - 25px);
    flex-shrink: 0;
    margin-bottom: 10px;
    margin-right: 25px;
    font-size: 12px;
    white-space: pre;
    ${(props) => (props.fullWidth ? `width: 100%;` : '')}
  `,
  IndicatorTitle: styled.div<{ underlineOnHover?: boolean; fullWidth: boolean }>`
    font-size: 10px;
    font-weight: bold;
    text-transform: uppercase;
    margin-top: 1px;
    display: flex;
    ${(props) => (props.underlineOnHover ? 'cursor: pointer;' : '')};
    ${(props) => (props.fullWidth ? `flex: 1;` : '')}
    ${(props) => (props.underlineOnHover ? 'text-decoration: underline;' : '')}
  `,
  IndicatorValue: styled.div<{ paddingOnLeft: boolean }>`
    padding-left: ${(props) => (props.paddingOnLeft ? '6px' : '0')};
    display: flex;
  `,
};
